import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { Link } from '@openx/components-core/lib/Link/Link.tsx';
import { StatusIndicator } from '@openx/components-core/lib/StatusIndicator/StatusIndicator.tsx';
import type { OaDealStatus } from '@openx/types/deal.ts';
import { useTranslation } from 'react-i18next';
import { useStatus } from './hooks/useStatus.ts';

type DealItemProps = {
  name: string;
  dealId: string;
  externalDealId: string;
  status: OaDealStatus;
};

export function DealItem({ name, dealId, externalDealId, status }: DealItemProps) {
  const { t } = useTranslation();
  const { label, color } = useStatus(status);

  return (
    <>
      <Typography variant="body1Bold">{name}</Typography>
      <Grid
        container
        sx={{
          alignItems: 'center',
        }}
      >
        <Grid size={{ xs: 2 }}>
          <StatusIndicator status={color} label={label} />
        </Grid>
        <Grid size={{ xs: 10 }}>
          <Stack
            direction="row"
            sx={{
              alignItems: 'center',
              gap: 1,
            }}
          >
            <Typography variant="body2" color="textSecondary">
              {t('Deal ID:')}
            </Typography>
            <Link to={`/deals/${dealId}/details`} data-test="audience-details-deal-id-link">
              {externalDealId}
            </Link>
          </Stack>
        </Grid>
      </Grid>
    </>
  );
}
